<div class="mt-2">
  <app-calendar></app-calendar>
</div>
